import { useTranslation } from 'react-i18next';
import { AssignedRole } from '../../../contexts/interfaces';
import { convertDate } from '../../../utils/convertDate';
import classes from './ProfileDetails.module.css';

interface Props {
    dateOfBirth: string,
    assignedRoles: AssignedRole[],
    employeeName: string,
    registerNumber: string,
}

const ProfileDetails = ({ dateOfBirth, employeeName, registerNumber, assignedRoles }: Props) => {
    // Set translation
    const { t } = useTranslation();

    return (
        <div className={classes.container}>
            <div className={classes.editRow}>
                <div className={classes.title}>
                    {t('profileDetails.mainTitle')}
                </div>
            </div>

            <table className={classes.table}>
                <tbody>
                    <tr>
                        <th>
                            {t('profileDetails.name')}
                        </th>
                        <th>
                            {t('profileDetails.dateOfBirth')}
                        </th>
                        <th>
                            {t('profileDetails.terhikkiNumber')}
                        </th>
                    </tr>

                    <tr>
                        <td className={classes.bolded}>
                            {employeeName}
                        </td>
                        <td className={classes.bolded}>
                            {convertDate(dateOfBirth)}
                        </td>
                        <td className={classes.bolded}>
                            {
                                registerNumber ||
                                t('profileDetails.applicantDoesntHaveRegisterNumber')
                            }
                        </td>
                    </tr>

                    <tr>
                        <th className={classes.marginTop}>
                            {t('profileDetails.jobTitle')}
                        </th>
                        <th className={classes.marginTop}>
                            {t('profileDetails.unit')}
                        </th>
                    </tr>
                    {/* Go through every unit/roles from unitRole -array and render new row into the table */}
                    {assignedRoles && assignedRoles.length > 0 ? assignedRoles.map((role, i) => {
                        return (
                            <tr
                                key={i}
                                className={classes.tableUnitRoleRow}
                            >
                                <td className={classes.bolded}>
                                    {role.jobTitle}
                                </td>
                                <td className={classes.bolded}>
                                    {role.unitName}
                                </td>
                            </tr>
                        )
                    })
                        : null
                    }
                </tbody>
            </table>

        </div>
    )
};
export default ProfileDetails;